export const TO_DELIVERY_FREE = 3000;
export const DELIVERY_PRICE = 300;